import React, { useMemo } from "react";
import "../styles/RecipeList.css";
import RecipeCard from "./RecipeCard";
import AIRecipe from "./AIRecipe";
import { useIngredients } from "../context/IngredientsProvider";

interface Recipe {
  nimi: string;
  kuvaus?: string;
  "raaka-aineet": string[];
  linkki?: string;
  kuva?: string;
  tarjoaja?: string;
}

interface RecipeListProps {
  recipes: Recipe[];
  aiRecipe: string | null;
  isLoading: boolean;
}

const RecipeList: React.FC<RecipeListProps> = ({
  recipes,
  aiRecipe,
  isLoading,
}) => {
  const { selectedIngredients } = useIngredients();

  const userIngredients = selectedIngredients.map((item) =>
    item.value.toLowerCase()
  );

  const sortedRecipes = useMemo(() => {
    const getRecipeMatchCount = (recipe: Recipe) => {
      return recipe["raaka-aineet"].filter((ingredient) =>
        userIngredients.includes(ingredient.toLowerCase())
      ).length;
    };

    return [...recipes].sort(
      (a, b) => getRecipeMatchCount(b) - getRecipeMatchCount(a)
    );
  }, [recipes, userIngredients]);

  return (
    <div className="recipe-list">
      {sortedRecipes.length === 0 && !aiRecipe ? (
        <p className="no-recipes-message">Ei löytynyt reseptejä.</p>
      ) : (
        <>
          {sortedRecipes.map((recipe, index) => (
            <div className="recipe-list-item" key={index}>
              <RecipeCard
                recipe={{
                  ...recipe,
                  tarjoaja: recipe.tarjoaja || "",
                  kuva: recipe.kuva || "",
                  linkki: recipe.linkki || "",
                }}
              />
            </div>
          ))}

          {aiRecipe && (
            <div className="recipe-list-item">
              <AIRecipe aiRecipe={aiRecipe} isLoading={isLoading} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RecipeList;
